import {
  divWithStyle,
  keyframes,
} from '@tableau/data-catalog-shared';
import { ActivitySpinnerSize, ActivitySpinnerWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';

const fadeInAnimation = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
});

const SpinnerContainer = divWithStyle('SpinnerContainer', {
  position: 'relative',
  paddingLeft: TabStyles.Spacing.DefaultSpace,
  animationName: fadeInAnimation,
  animationDuration: '500ms',
  animationTimingFunction: 'ease-in',
  height: ActivitySpinnerSize.Small // ensures the div doesn't change size due to rotation of spinner
});

export function SmallInlineFadeInSpinner(): JSX.Element {
  return (
    <SpinnerContainer>
      <ActivitySpinnerWidget spinnerSize={ActivitySpinnerSize.Small} testId='' />
    </SpinnerContainer>
  );
}
